
const m = window.require("@ember/object/lib/computed/computed_macros");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
